<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_ATTEND)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="confirmStart(item)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-doctor
              </v-icon>
            </v-btn>
          </template>
          <span>Atender</span>
        </v-tooltip>
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_CANCEL)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-stop
              </v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.startTime) }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialogConfirmStart" persistent max-width="500">
    <v-card elevation="2">
      <v-banner
        style="background-color: #60845c;"
        icon="mdi-information white--text "
        
        single-line
        class="pr-2"
      >
        <span class="text-h6 font-weight white--text">Atención</span>
      </v-banner>

      <v-card-subtitle class="subtitle-1 mt-3">
        ¿Está seguro? La consulta se iniciará.
      </v-card-subtitle>

      <v-divider class="mt-2"></v-divider>

      <v-card-actions class="d-flex justify-end">
        <v-btn text @click="dialogConfirmStart = false">
          Cancelar
        </v-btn>
        <v-btn text color="primary" @click="startConsultation">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <v-dialog
      v-model="dialogCancelation"
      v-if="dialogCancelation"
      persistent
      max-width="70%"
    >
      <cancelation-modal
        ref="cancelationModal"
        :dataModal="dataModal"
        @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import TelemedicinePendingService from "@/app/services/TelemedicinePendingService"
export default {
  name: "TelemedicinePendingTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      dialogConfirmStart: false,
      selectedItem: null, 
      headers: [
        {
          text: "Id Consulta",
          value: "idMedicalPractice",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Nombre del paciente",
          value: "fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de solicitud",
          value: "startTime",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    confirmStart(item) {
      this.selectedItem = item;
      this.dialogConfirmStart = true;
    },
    async startConsultation() {
  if (this.selectedItem) {
    try {
      await TelemedicinePendingService.get({
        idMedicalPractice: this.selectedItem.idMedicalPractice,
      });
      this.$toast.success("El paciente ha pasado a Por Iniciar");
      this.$router.go(0);
    } catch (error) {
      console.error("Error al iniciar la consulta:", error);
      this.$toast.error("Ocurrió un error al iniciar la consulta.");
    } finally {
      this.dialogConfirmStart = false;
    }
  }
},
    checkCancel(item) {
      this.dataModal = Object.assign({}, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
  },
};
</script>
